// Central place for runtime configuration.
// In production, values are injected at container startup via window.__env__
// (generated by docker-entrypoint.sh from pod env vars sourced from AWS Secrets Manager).
// For local development, set values in public/env.js.
const env = (window as any).__env__ || {};
const get = (key: string): string => env[key] || "";

const fallbackOrigin = typeof window !== "undefined" ? window.location.origin : "";

export const API_BASE_URL = get("REACT_APP_API_BASE_URL") || "https://localhost:44338";
export const CREATE_PAYMENT_PATH = get("REACT_APP_CREATE_PAYMENT_PATH") || "/FexcoPayment";
export const PAYMENT_RECORDS_PATH = get("REACT_APP_PAYMENT_RECORDS_PATH") || "/FexcoPayment/GetAll";

export const AUTH0_DOMAIN = get("REACT_APP_AUTH0_DOMAIN");
export const AUTH0_CLIENT_ID = get("REACT_APP_AUTH0_CLIENT_ID");
export const AUTH0_REDIRECT_URI = get("REACT_APP_AUTH0_REDIRECT_URI") || fallbackOrigin + "/paymentrecords";
export const AUTH0_AUDIENCE = get("REACT_APP_AUTH0_AUDIENCE");

export const COMPANY_OPTIONS = (get("REACT_APP_COMPANIES") || "LEX,LME")
  .split(",")
  .map((x: string) => x.trim())
  .filter(Boolean);

export const buildCreatePaymentUrl = () => `${API_BASE_URL}${CREATE_PAYMENT_PATH}`;
export const buildPaymentRecordsUrl = (search: string | null) =>
  `${API_BASE_URL}${PAYMENT_RECORDS_PATH}?search=${search ?? ""}`;
